import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCaretDown, faCaretUp } from "@fortawesome/free-solid-svg-icons";

import CustomCard from "../Exam Card/customCard.component";
import "./examPreview.styles.scss";

const ExamPreview = ({ assessmentTitle, subjects }) => {
  const [show, hide] = useState(true);
  return (
    <div className="exam-collection-preview">
      <span className="Field">
        {assessmentTitle}
        <FontAwesomeIcon
          icon={show ? faCaretUp : faCaretDown}
          onClick={() => hide(!show)}
          style={{ marginLeft: 10 }}
        />
      </span>
      {show ? (
        <div className="preview">
          {subjects
            .filter((eachSubject, idx) => idx < 6)
            .map((eachSubject) => (
              <CustomCard key={eachSubject.id} subject={eachSubject} />
            ))}
        </div>
      ) : null}
    </div>
  );
};

export default ExamPreview;
